/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgFlagCanada(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={18}
      fill='none'
      viewBox='0 0 24 18'
      {...props}
    >
      <path fill='#fff' d='M8 0h8v18H8z' />
      <path
        fill='#FE0000'
        d='M24 17a1 1 0 01-1 1h-7V0h7a1 1 0 011 1v16zM8 18H1a1 1 0 01-1-1V1a1 1 0 011-1h7v18z'
      />
      <path
        fill='#FE0000'
        fillRule='evenodd'
        d='M12.438 12.344s-.219-1.667-.109-1.65l1.354.21c-.477-.902.722-1.338 1.338-1.862-.478-.161-.413-.102-.106-1.249-.996.317-.915.224-1.126-.27l-.702.793c-.089.1-.238.033-.207-.12.325-1.608.341-1.673.341-1.673-.633.382-.609.404-.709.206C12.164 6.052 12 5.72 12 5.72s-.165.333-.512 1.01c-.1.197-.077.175-.71-.207 0 0 .016.066.341 1.673.032.154-.117.221-.207.12-.623-.704-.7-.793-.7-.793-.213.495-.13.587-1.128.271.308 1.146.373 1.087-.105 1.249.617.524 1.816.96 1.338 1.861l1.354-.209c.11-.018-.077 1.681-.077 1.681l.844-.031z'
      />
    </svg>
  );
}

export default SvgFlagCanada;
